/**
 * Performs PDF generation for a NIACS project document.
 * The logic here is relatively simple conceptually and the implementation has limitations.
 * The generate method gets called with a jQuery DOM element
 * to translate into a PDF.  The element is then re-cursed looking for
 * a subset of nested children that it knows how to render into the
 * PDF document.  "Instructions" are supplied to the process which dictate
 * what elements should be rendered and some info about how they should be
 * rendered (margins, normal, bold, italic, etc.).  Each tag name can have an
 * ordered list of 'classes' which can be used to individually style elements in
 * the PDF in a fashion similar, though much more rudimentary in nature, to css.
 * CSS class names are consulted to decide the formatting to apply.
 * Complex elements can take over the PDF rendering by implementing an append method
 * (e.g. UL/DL).  This code could probably be genericized but was crafted specifically
 * for NIACS in a short period of time.
 */
niacs.pdf = {
    PAGE_HEIGHT: 11,
    PAGE_WIDTH: 8.5,
    /**
     * Given a tag and the base formatting instructions for that
     * tag consult the tag's CSS classes (if any) and construct
     * the formatting instructions specific to the given tag.
     *
     * @param  {jQuery element} tag The jQuery DOM element.
     * @param  {object} fmt The base formatting instructions for the tag.
     * @return {object}     The final formatting instructions for the tag.
     */
    instructions: function(tag,fmt) {
        if(!fmt.classes) {
            return fmt; /* no sub-styling defined */
        }
        var classesAtrr = tag.attr('class'),
            classes = classesAtrr ? classesAtrr.split(' ') : [],
            nFmt = fmt,
            extended = null;
        if(classes.length > 0) {
            for(var i = 0; i < classes.length; i++) {
                if(fmt.classes[classes[i]]) {
                    if(extended === null) {
                        angular.extend((extended={}),fmt);
                        nFmt = extended;
                        delete extended.classes;
                    }
                    angular.extend(extended,fmt.classes[classes[i]]);
                }
            }
        }
        return nFmt;
    },
    /**
     * Appends some text to the PDF document at the current location.
     * This deals with paragraphs of text but considers the paragraph's
     * vertical height as a whole when deciding when to insert page breaks
     * meaning that a given paragraph won't span a page break so there may
     * be dead space at the end of a given page if that happens.
     *
     * @param  {jQuery Element} t      The jQuery tag to extract the text from.
     * @param  {jsPDF} pdf    The PDF document.
     * @param  {object} fmt    The base formatting instructions.
     * @param  {object} tagFmt Tag specific formatting instructions.
     */
    appendText: function(t,pdf,fmt,tagFmt) {
        if(tagFmt.marginTop) {
            fmt.voff += tagFmt.marginTop;
        }
        if(angular.isNumber(tagFmt.indent)) {
            if(tagFmt.indent === 0) { // reset
                fmt.indent = 0;
            } else {
                fmt.indent += tagFmt.indent;
            }
        }
        var text = t.text(),
            fsize = tagFmt.size,
            lines = pdf.setFontSize(fsize)
                       .setFontStyle(tagFmt.style)
                       .splitTextToSize(text,(fmt.maxline-fmt.indent)),
            nextOff = fmt.voff+((lines.length+0.5)*fsize/fmt.scaleFactor)+tagFmt.marginBottom;
        // TODO should really output lines one at a time to let paragraphs span page boundaries.
        if(nextOff > (niacs.pdf.PAGE_HEIGHT-fmt.bottom)) {
            fmt.voff = fmt.top;
            nextOff = fmt.voff+((lines.length+0.5)*fsize/fmt.scaleFactor)+tagFmt.marginBottom;
            pdf.addPage();
        }
        pdf.text((fmt.left+fmt.indent),fmt.voff+fsize/fmt.scaleFactor,lines);
        fmt.voff = nextOff;
        // apply an underline if instructed to
        if(tagFmt.underline || tagFmt.hr){
            fmt.voff -= tagFmt.marginBottom;
            pdf.setLineWidth(tagFmt.underline || tagFmt.hr);
            var right = (fmt.left+fmt.maxline); // assume hr
            if(tagFmt.underline) {
                // need to calculate where to end the line based on the width of the text in question.
                // this code obviously means no multi-line underline (not needed for the time being).
                right = fmt.left+fmt.indent+(1.0 * pdf.getStringUnitWidth(text) * tagFmt.size / fmt.scaleFactor);
            }
            pdf.line((fmt.left+fmt.indent),fmt.voff,right,fmt.voff);
            fmt.voff += tagFmt.marginBottom;
        }
    },
    /**
     * Recurses a HTML DOM element (jQuery) looking for tags to render into a
     * the given PDF document.
     *
     * @param  {jQuery element} elm The jQuery DOM element.
     * @param  {jsPDF} pdf The PDF document.
     * @param  {object} fmt The formatting instructions.
     */
    appendChildren: function(elm,pdf,fmt) {
        elm.children().each(function(){
            var t = $(this),
                tag = t.prop('tagName'),
                tagFmt = fmt[tag] ? niacs.pdf.instructions(t,fmt[tag]) : null;
            /*
            if(tagFmt) {
                console.log('processing',tag,t,tagFmt);
            }*/
            if(tagFmt && tagFmt.append) {
                tagFmt.append(t,pdf,fmt,tagFmt); // let the custom implementation deal with all children.
            } else {
                if(tagFmt) {
                    niacs.pdf.appendText(t,pdf,fmt,tagFmt);
                }
                niacs.pdf.appendChildren(t,pdf,fmt);
            }
        });
    },
    /**
     * Given a jQuery DOM element recurse it and return a PDF
     * document.
     *
     * @param  {jQuery Element} root The jQuery DOM element.
     * @return {jsPDF}      The rendered PDF document.
     */
    generate: function(root) {
        var pdf = new jsPDF('p','in','letter');
        //console.log('fontList',pdf.getFontList());
        pdf.setFont(niacs.pdf.fmt.font);
        pdf.setFontSize(niacs.pdf.fmt.fontSize);
        niacs.pdf.fmt.indent = 0;
        niacs.pdf.fmt.voff = (niacs.pdf.fmt.top || 0.5);
        niacs.pdf.appendChildren(root,pdf,niacs.pdf.fmt);
        return pdf;
    },
    /**
     * These are the HTML to PDF formatting instructions.  They were crafted
     * specifically for the NIACS project document based on how it should be
     * rendered by comparing the results of CSS print rules to generated PDF
     * content. UL/DL processing is custom embedded in these instructions but
     * could probably be genericised.
     *
     * @type {Object}
     */
    fmt: {
        H5: {
            size:11,
            style: 'bold',
            marginTop: 0.1,
            marginBottom: 0.1
        },
        LABEL: {
            size: 11,
            style: 'bold',
            marginBottom: 0,
            classes: {
                'print-fw' : {
                    size: 13,
                    hr: 0.01,
                },
                'final-fw' : {
                    hr: 0.01,
                    marginTop: 0.1,
                },
                'print-fw-noindent' : {
                    indent: 0 // reset indent to zero
                },
                'final-ul' : {
                    underline: 0.01,
                    marginBottom: 0.1,
                }
            }
        },
        /*
        A: {
            size: 11,
            style: 'normal',
            marginTop: 0,
            marginBottom: 0
        },*/
        P: {
            size: 11,
            style: 'normal',
            marginTop: 0.06,
            marginBottom: 0.06,
            classes: {
                'no-margin' : {
                    marginTop: 0,
                    marginBottom: 0
                }
            }
        },
        UL: {
            size:11,
            style: 'normal',
            indent: 0.2,
            bulletRadius: 0.02,
            classes: {
                'list-unstyled': {
                    bulletRadius: 0
                }
            },
            append: function(elm,pdf,fmt,tagFmt) {
                var nIndent = angular.isNumber(tagFmt.indent) ? tagFmt.indent : 0;
                fmt.indent += nIndent;
                elm.children('li').each(function(){
                    var liIndent = 0;
                    if(tagFmt.bulletRadius) {
                        pdf.setLineWidth(0.01);
                        pdf.setDrawColor(0);
                        pdf.circle((fmt.left+fmt.indent),fmt.voff+tagFmt.size/fmt.scaleFactor,tagFmt.bulletRadius,'FD');
                        liIndent = tagFmt.bulletRadius*4;
                    }
                    fmt.indent += liIndent;
                    var t = $(this);
                    if(t.children().length === 0) {
                        /*
                         KNOWN ISSUE: there's an issue here that if an li doesn't wrap another tag (e.g. <p> then the PDF is truncated...)
                         */
                        var liFmt = {};
                        angular.extend(liFmt,tagFmt);
                        delete liFmt.indent;
                        niacs.pdf.appendText(t,pdf,fmt,liFmt);
                    } else {
                        niacs.pdf.appendChildren(t,pdf,fmt);
                    }
                    fmt.indent -= liIndent;
                });
                fmt.indent -= nIndent;
            }
        },
        DL: {
            size: 11,
            ddMargin: 0.1,
            marginBottom: 0.2,
            classes: {
                'final-vuln-det': {
                    indent: 0,
                    marginTop: 0.1,
                    ddMargin: 0.5 // shouldn't be necessary?
                },
                'final-feasibility': {
                    indent: 0,
                    marginBottom: 0,
                }
            },
            append: function(elm,pdf,fmt,tagFmt) {
                function _w(text) {
                    return (1.0 * pdf.getStringUnitWidth(text) * tagFmt.size / fmt.scaleFactor);
                }
                // set style to bold so that widths of dt labels include
                // strong font.
                pdf.setFontStyle('bold');
                var nIndent = (tagFmt.indent||0),
                    ddMargin = (tagFmt.ddMargin||0),
                    bullets = [],
                    w,maxDt = 0.0,i,bullet,nextOff,lines,maxDd;
                //nIndent = angular.isNumber(tagFmt.indent) ? tagFmt.indent : 0.1;
                if(tagFmt.marginTop) {
                    fmt.voff += tagFmt.marginTop;
                }
                fmt.indent += nIndent;
                elm.children().each(function(){
                    var t = $(this),
                        tag = t.prop('tagName');
                    if('DT' == tag) {
                        bullet = {dt: t.text()};
                        w = _w(bullet.dt); // size in inches
                        if(w > maxDt) {
                            maxDt = w;
                        }
                        bullets.push(bullet);
                    } else if('DD' == tag) {
                        bullets[bullets.length-1].dd = t.text();
                    }
                });
                maxDd = fmt.maxline-fmt.indent-maxDt-ddMargin;
                for(i = 0; i < bullets.length; i++) {
                    bullet = bullets[i];
                    pdf.setFontStyle('bold'); // calculate width as bold or things won't line up.
                    w = _w(bullet.dt);
                    lines = pdf.splitTextToSize(bullet.dd,maxDd);
                    nextOff = fmt.voff+((lines.length+0.5)*tagFmt.size/fmt.scaleFactor);
                    if(nextOff > (niacs.pdf.PAGE_HEIGHT-fmt.bottom)) {
                        fmt.voff = fmt.top;
                        nextOff = fmt.voff+((lines.length+0.5)*tagFmt.size/fmt.scaleFactor);
                        pdf.addPage();
                    }
                    // output label
                    pdf.text((fmt.left+fmt.indent+(maxDt-w)),fmt.voff+tagFmt.size/fmt.scaleFactor,bullet.dt);
                    // output text
                    pdf.setFontStyle('normal');
                    pdf.text((fmt.left+fmt.indent+maxDt+ddMargin),fmt.voff+tagFmt.size/fmt.scaleFactor,lines);
                    fmt.voff = nextOff;
                }
                fmt.indent -= nIndent;
                fmt.voff += (tagFmt.marginBottom||0);
            }
        },
        // document wide settings.
        top: 0.5, // top page margin
        left: 0.5, // left page margin
        maxline: 7.5, // max line length (defines right page margin)
        bottom: 0.5, // bottom page margin
        font: 'helvetica', // other styles like bold, etc. are bound to the font name
        fontSize: 11,
        scaleFactor: 72,

        // these are variables that are used/updated during generation.
        indent: 0,
        voff: 0.5 /* current vertical offset during generation */
    }
};